import { Modal, Space } from 'antd';

import { JobPostingActionModal } from './VacancyActions';

const ConcludeVacancyModal: React.FC<JobPostingActionModal> = ({ jobPosting, ...props }) => {
  return (
    <Modal {...props}>
      <Space direction="vertical">
        {jobPosting.filled_positions < jobPosting.positions && (
          <span>
            A vaga <strong>{jobPosting.name}</strong> não pode ser concluída, pois tem apenas{' '}
            {jobPosting.filled_positions} pessoa(s) contratada(s) que é inferior a quantidade de{' '}
            {jobPosting.positions} posições definidas durante a abertura da vaga. Altere o número de
            posições editando a vaga antes de concluí-la.
          </span>
        )}
        {jobPosting.filled_positions >= jobPosting.positions && (
          <>
            <span>
              Lembrete: Você já <b>enviou feedback para todos os candidatos?</b> Lembre-se que falta
              de retorno do processo seletivo é o principal motivo de insatisfação com a marca
              empregadora e isso pode afetar a sua atração no longo prazo.
            </span>
            <div>
              Tem certeza que deseja concluir a vaga <strong>{jobPosting.name}</strong>?
            </div>
          </>
        )}
      </Space>
    </Modal>
  );
};

export default ConcludeVacancyModal;
